import styled from '@emotion/styled';

import { visuallyHidden } from '@styles/mixins/visuallyHidden';

export const Title = styled.h2`
  ${visuallyHidden}
`;

export const TextPartHighlight = styled.span`
  position: relative;
`;
